import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import {
  selectOrderState,
  setSearchFilter,
  setStatusFilter,
} from "../../../store/order/orderFilterSlice";
import classes from "./orderFilterPage.module.css";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";
import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";

const statusses = [
  { id: "", label: "Select Approval Status" },
  { id: "approved", label: "Approved" },
  { id: "rejected", label: "Rejected" },
];

export const OrderFilterPage = () => {
  const filters = useSelector(selectOrderState);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  // Sync URL params to Redux on mount
  useEffect(() => {
    const statusParam = searchParams.get("status") || null;
    const searchParam = searchParams.get("search") || null;

    if (filters.status !== statusParam) {
      dispatch(setStatusFilter(statusParam));
    }
    if (filters.search !== searchParam) {
      dispatch(setSearchFilter(searchParam));
    }
  }, [searchParams, dispatch, filters]);

  const updateFilter = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);

    if (value) newSearchParams.set(key, value);
    else newSearchParams.delete(key);

    setSearchParams(newSearchParams);

    if (key === "status") dispatch(setStatusFilter(value));
    if (key === "search") dispatch(setSearchFilter(value));
  };

  const handleSearch = (text) => updateFilter("search", text);
  const handleClearSearch = () => updateFilter("search", null);
  const handleSelection = (key, value) => {
    updateFilter(key, value);
  };

  return (
    <div className={classes.box}>
      {/* Search Input */}
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          onSearch={handleSearch}
          searchTextFrmStore={filters.search}
          searchFilter={!!filters.search}
          onClear={handleClearSearch}
        />
      </div>

      {/* Status Select */}
      <div className={classes.box__content}>
        <CustomDropdown
          id="status"
          label="Select Approval Status"
          options={statusses}
          selectedId={filters.status || ""}
          onSelection={handleSelection}
        />
      </div>
    </div>
  );
};
